import React from "react";
import Layout from "../../Components/Dashboard/Layout/Layout";
import PayoutsSection1 from "../../Components/Dashboard/Payouts/PayoutsSection1";

const Payouts = () => {
  return (
    <>
      <Layout>
        <div
          className="dashboard__content hover-bgc-color"
          style={{ marginTop: "6%" }}
        >
          <PayoutsSection1 />
        </div>
      </Layout>
    </>
  );
};

export default Payouts;
